import React, { Component, useState } from "react";
import { useSelector } from "react-redux";

import { ReactComponent as NOAUTHORIZED } from "../../build/images/whatsvoznoauthorized.svg";
import { ReactComponent as EYECLOSED } from "../../build/images/eyeclosed.svg";
import { ReactComponent as EYEOPEN } from "../../build/images/eyeopen.svg";
import { ReactComponent as CLOSEICON } from "../../build/images/close.svg";

import returnRoute from "../../actions/returnRoute";

import "./notification-voz.css";

export default function NoAuthorized({ actionSend, midiaId, numeroDoCliente, bind }) {
    const PermissionRouter = useSelector((state) => state.routergroups);
    const [isExpand, setExpand] = useState(false);

    const handleSendHsm = () => {
        console.log("DADOS 1", midiaId)
        console.log("DADOS 2", numeroDoCliente)
        const routesSelected = returnRoute(midiaId, numeroDoCliente, PermissionRouter)
        console.log("DADOS 3", routesSelected)
        if(routesSelected.length > 1){
            document.querySelector('#select-route-active-call-midia__drop-down-container-5 button').click();
        }
    }

  return (
    <div className="container-alert__notification">
        <div className="container-alert__notification-box">
            <div>
                <NOAUTHORIZED />
            </div>
            <div className="container-alert__notification-texts">
                <div className="container-alert__notification-title">Chamada via WhatsApp Voz bloqueada</div>
                <div className="container-alert__notification-subtitle">
                    Este cliente ainda não autorizou ligações de voz da empresa no WhatsApp.
                    {/* Envie o modelo de mensagem orientando o cliente a liberar a chamada. */}
                </div>
                {isExpand &&
                    <div className="container-alert__notification-subtitle"><br />
                        Para liberar:<br />
                        1. Selecione o ícone de WhatsApp Chat acima.<br />
                        2. Escolha a rota/número da empresa que deseja utilizar.<br />
                        3. Clique em *Enviar Template* selecione modelo que deseja enviar orientando ao cliente faça o desbloqueio no celular dele.
                    </div>
                }
                <div className="container-alert__notification-action" 
                    onClick={() => setExpand(!isExpand)}
                >
                    {isExpand ? 
                        <>
                            <EYECLOSED />
                            <div>Ver menos</div>
                        </>
                        :
                        <>
                            <EYEOPEN />
                            <div>
                                Ver mais
                            </div>
                        </>
                    }
                </div>
            </div>
        </div>
        <div className="action__close-alert" onClick={() => actionSend(bind)}>
            <CLOSEICON />
        </div>
    </div>
  );
}
